import React from 'react';
import { Dropdown, Space, message } from 'antd';
import logOutIcon from 'assets/images/logout.svg';
import { DownOutlined } from '@ant-design/icons';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logout } from '../../redux/user';
import { localize } from '../../locales';
import './index.css';

const Header = () => {
	const userInfo = useSelector((state) => {
		return state.user;
	});
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const items = [
		{
			key: '1',
			label: 'Logout',
			icon: <img src={logOutIcon} alt="" />,
		},
	];

	const handleMenuClick = (e) => {
		if (e.key === '1') {
			dispatch(logout());
			message.success(localize('logoutSuccess'));
			// instance.logoutRedirect();
			navigate('/login');
		}
	};
	const menuProps = {
		items,
		onClick: handleMenuClick,
	};

	function getInitials(fullName) {
		if (!fullName) {
			return '';
		}

		const nameWithoutExt = fullName.replace(/\s*\([^)]*\)\s*/g, '');

		const words = nameWithoutExt.trim().split(/\s+/);

		let initials = '';

		if (words.length === 1) {
			initials = words[0].charAt(0).toUpperCase();
		} else if (words.length === 2) {
			initials = words.map((word) => word.charAt(0).toUpperCase()).join('');
		} else {
			initials = words[0].charAt(0).toUpperCase() + words[words.length - 1].charAt(0).toUpperCase();
		}

		return initials;
	}

	return (
		<div className="header-container">
			<div className="welcome-section">Welcome to Henkel AI Hub</div>
			<div className="user-section">
				<div className="user-group">
					<div className="hi-container">Hi,</div>
				</div>
				<Dropdown menu={menuProps} trigger={['click']} arrow placement="bottom">
					<div className="user-info">
						<div>
							<Space>
								<div className="icon-container">
									<span className="name-init">{getInitials(userInfo?.email)} </span>
								</div>
								{userInfo?.email ?? ''}
								<DownOutlined />
							</Space>
						</div>
					</div>
				</Dropdown>
			</div>
		</div>
	);
};

export default Header;
